import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import {
  GetPvtVdsFilterInput,
  GetPvtVdsSortInput,
  PvtVds,
  StructureInput,
} from '@lib/domain/stuctures';

export const GET_PVT_VDS = gql`
  query getPvtVds(
    $structure: StructureInput
    $election: String
    $limit: Int
    $offset: Int
    $filter: GetPvtVdsFilterInput
    $sort: [GetPvtVdsSortInput!]
  ) {
    getPvtVds(
      structure: $structure
      election: $election
      pagination: { limit: $limit, offset: $offset }
      sort: $sort
      filter: $filter
    ) {
      structure {
        name
        code
        type
        province
        region
        constituency
        municipality
        ward
      }
      assignedTo {
        sub
        name
      }
      status
      updatedAt
      score
      id
      latestVersion
      iecUpdatedAt
      isFlagged
      has_ballot_upload
      has_iec_count
      has_agent_count
      statusAt
      totalQueryResultCount
    }
  }
`;

interface UseGetPvtVdsReturns {
  loading: boolean;
  error?: any;
  getPvtVds?: PvtVds[];
  refetch: () => void;
}

export default function useGetPvtVds(
  structure: StructureInput | null,
  election: string | undefined,
  limit: number | null,
  offset: number | null,
  filter: Partial<GetPvtVdsFilterInput>,
  sort: GetPvtVdsSortInput | null
): UseGetPvtVdsReturns {
  const { loading, error, data, refetch } = useQuery<{ getPvtVds: PvtVds[] }>(
    GET_PVT_VDS,
    {
      variables: {
        structure,
        election,
        limit,
        offset,
        filter,
        sort,
      },
      skip: !structure || !election,
    }
  );
  return {
    loading,
    error,
    getPvtVds: data?.getPvtVds,
    refetch,
  };
}
